import { trpc } from "../../../utils/trpc";
import { useServerId } from "../hooks/use_server_id";
import { PlaceholderRow } from "./event_template_list";
import { LoadingThrobber } from "../base_components/loading_throbber";
import { TemplateSelection } from "./event_template_page";
import { EventTemplateModalRow } from "./event_template_modal_row";
import { SeshPrimaryButton } from "../base_components/sesh_primary_button";
import { DateTime } from "luxon";
import { TRPCClientErrorLike } from "@trpc/client";
import { UseTRPCQueryResult } from "@trpc/react-query/dist/shared";
import type {
	AppRouter,
	RouterInferenceHelpers,
} from "../../../../../../src/api/trpc/rootRouter";
import { RemovingThrobber } from "../../removing_throbber";

type UseGetBookmarkedListQueryType = UseTRPCQueryResult<
	RouterInferenceHelpers["event_template"]["getBookmarkedList"]["output"],
	TRPCClientErrorLike<AppRouter>
>;

export function EventTemplateBookmarkedList(props: {
	setSelectedTemplate: (template: TemplateSelection) => void;
	setSelectedInfoTemplate: (template: TemplateSelection) => void;
	onUseClick: (template: TemplateSelection) => void;
	search: string;
	selected_template: TemplateSelection | null;
	event_list_query: UseGetBookmarkedListQueryType;
}) {
	const server_id = useServerId();

	const event_list_query = props.event_list_query;

	const context = trpc.useContext();
	const mutation = trpc.event_template.deleteBookmark.useMutation({
		onSuccess: (data) => {
			context.event_template.getBookmarkedList.invalidate({
				guild_id: server_id,
			});
		},
	});

	if (!event_list_query.isSuccess) {
		return (
			<PlaceholderRow>
				<div className="flex  items-center gap-2">
					Loading <RemovingThrobber />
				</div>
			</PlaceholderRow>
		);
	}

	const filtered_templates = props.search
		? event_list_query.data.filter((item) =>
				item.name.toLowerCase().includes(props.search.toLowerCase())
		  )
		: event_list_query.data;

	return (
		<div className="flex flex-col gap-1">
			{filtered_templates.length > 0 ? (
				<div className="flex flex-col gap-1">
					{filtered_templates.map((item) => (
						<EventTemplateModalRow
							key={item.id}
							item_id={item.id}
							bookmark_id={item.id}
							item_name={item.name}
							author_id={item.author_id}
							created_at={DateTime.fromJSDate(
								new Date(item.created_at)
							)}
							selected_template={props.selected_template}
							onUseClick={() =>
								props.onUseClick({
									template_id: item.id,
									name: item.name,
								})
							}
							onRowClick={() => {
								props.setSelectedTemplate({
									template_id: item.id,
									name: item.name,
								});
							}}
							onFavoriteClicked={() => {
								mutation.mutate({
									template_id: item.id,
								});
							}}
							onInfoClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								props.setSelectedInfoTemplate({
									template_id: item.id,
									name: item.json.event_name,
								});
							}}
							is_event_list={false}
						/>
					))}
				</div>
			) : (
				<PlaceholderRow>
					<div className="w-full px-4 text-left text-content-secondary">
						No favorited templates
					</div>
				</PlaceholderRow>
			)}
		</div>
	);
}
